import { useHookstate } from "@hookstate/core";
import { Comic, ComicLang } from "../../types";
import { appStore } from "../../hookstate/appStore";
import { Flex } from "@chakra-ui/react";
import { SlimTag } from "../tags/SlimTag";
import { Link } from "react-router-dom";

export function ComicLanguageLabels({ comicData }: { comicData?: Comic }) {
  const langs = comicData?.comic_langs;
  const { languages } = useHookstate(appStore.init).get({
    noproxy: true,
  });

  const languageLabels = langs
    ?.map((lang: ComicLang) => {
      const langName = languages?.find((l) => l.id === lang.lang_id)?.name;
      if (!langName) return lang;
      return { ...lang, name: langName };
    })
    .filter((lang): lang is ComicLang => !!lang);

  return (
    <Flex gap="12px" width="100%" flexDirection="row" flexWrap="wrap">
      {languageLabels?.map((lang) => (
        <Link to={`/read/${lang?.first_release_uuid}`}>
          <SlimTag text={lang.name} key={lang.id} />
        </Link>
      )) ?? []}
    </Flex>
  );
}
